const config = {
    environment: "PRODUCTION",
};

export default config;
